import { render, staticRenderFns } from "./stocklogList.vue?vue&type=template&id=2570b4e9&scoped=true"
import script from "./stocklogList.vue?vue&type=script&lang=js"
export * from "./stocklogList.vue?vue&type=script&lang=js"
import style0 from "./stocklogList.vue?vue&type=style&index=0&id=2570b4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570b4e9",
  null
  
)

export default component.exports